import React, { useRef, useEffect } from 'react';
import { useDashboardData } from './Dashboard';
import { formatPrice } from '../../utils/formatHelper';
import InfoTooltip from './InfoTooltip';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const RevenueChart = () => {
  const { charts: data } = useDashboardData();
  const chartRef = useRef(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!data || !canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    const ctx = canvasRef.current.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 250);
    gradient.addColorStop(0, 'rgba(16, 185, 129, 0.8)');
    gradient.addColorStop(1, 'rgba(16, 185, 129, 0.2)');

    chartRef.current = new Chart(canvasRef.current, {
      type: 'bar',
      data: {
        labels: data.revenueGrowth?.labels || [],
        datasets: [{
          label: 'Gelir',
          data: data.revenueGrowth?.data || [],
          backgroundColor: gradient,
          borderColor: '#10b981',
          borderWidth: 1,
          borderRadius: 4,
          barPercentage: 0.5
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => formatPrice(ctx.parsed.y)
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (v) => v >= 1000 ? `${(v/1000).toFixed(0)}K` : v,
              font: { size: 11 }
            },
            grid: { color: 'rgba(0,0,0,0.04)' }
          },
          x: {
            grid: { display: false },
            ticks: { font: { size: 11 } }
          }
        }
      }
    });

    return () => { chartRef.current?.destroy(); };
  }, [data]);

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-chart-area me-2" style={{ color: '#10b981' }}></i>
          Gelir Trendi (6 Ay)
          <InfoTooltip text="Son 6 aydaki aktif aboneliklerinizin ürettiği Aylık Düzenli Gelir (MRR) gelişimi." />
        </div>
      </div>
      <div className="detail-panel-body">
        {!data ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : (
          <div style={{ height: '250px' }}>
            <canvas ref={canvasRef} />
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueChart;
